




import { defineComponent, onMounted, ref, PropType, onBeforeUnmount } from '@vue/composition-api';
import type { TransparentVideoPlayer, TransparentVideoPlayerConfig } from '@ks/tvplayer';
export default defineComponent({
    props: {
        playerConfig: {
            type: Object as PropType<TransparentVideoPlayerConfig>,
        },
    },
    setup(props, { emit }) {
        const animPlayerContainer = ref<HTMLDivElement | null>(null);
        const player = ref<TransparentVideoPlayer | null>(null);
        onMounted(() => {
            const { TransparentVideoPlayer } = require('@ks/tvplayer');
            const config = Object.assign({
                wrapper: animPlayerContainer.value,
                autoPlay: true,
                loop: true,
                premultipliedAlpha: true, // 视频是否预透明
                ratio: 2, // 分辨率, 推荐使用 device pixel ratio
            }, props.playerConfig);
            if (props.playerConfig) {
                player.value = new TransparentVideoPlayer(config);
                player.value?.addEventListener('videoEnded', () => {
                    emit('anim-video-ended');
                });
            }
        });
        function play() {
            if (player.value) {
                player.value.play();
            }
        }
        function pause() {
            if (player.value) {
                player.value.pause();
            }
        }
        function destroy() {
            if (player.value) {
                player.value.destroy();
            }
        }
        onBeforeUnmount(() => {
            destroy();
        });
        return {
            animPlayerContainer,
            play,
            pause,
            destroy,
        };
    },
});

